import type { FC } from "react";
import { useEffect } from "react";

import styled from "styled-components";

import { getUpdatedGranularityItemsState } from "app/components/campaigns/shared/overview/utils";
import type { DatesRange } from "app/pages/digital-marketing/brand-monitoring-campaigns/reports/ads-report/shared/BrandMonitoringAdsReportUtils";
import DurationService from "app/services/DurationService";
import { GranularityNames } from "app/UtilitiesAndConstants/Constants/Moment";

import { TIME_GRANULARITY, getTimeGranularityItems } from "./components/consts";
import { GenericDropdownFilter } from "./components/GenericDropdownFilter";

const RankTrackerOverviewPerformanceFiltersContainer = styled.div`
    .dynamicFilter.overview-performance-dynamic-filters {
        width: 100% !important;
    }
`;

const TITLE_KEY = "TimeGranularity";
const KEY = "dynamicFiltersContainer";
const DEFAULT_GRANULARITY = GranularityNames.DAILY;

interface IGranularityFilterDisabledStatesRecord {
    daily: boolean;
    weekly: boolean;
    monthly: boolean;
}

interface IFilterObject {
    [TIME_GRANULARITY]: string;
}

export const RankTrackerOverviewPerformanceGraphWidgetFilters: FC<any> = (props) => {
    const { widgetFilters: filterObject, changeFilter: onFilterChangeCallback, widgetDuration } = props;

    useEffect(() => {
        if (!filterObject[TIME_GRANULARITY]) {
            onFilterChange(TIME_GRANULARITY, DEFAULT_GRANULARITY);
        }
    }, []);

    const onFilterChange = (filterName: keyof IFilterObject, value: string) => {
        const newData = { ...filterObject, [filterName]: value };

        const updatedFilters = Object.entries(newData).map(([key, value]) => ({
            name: key,
            value,
        }));

        onFilterChangeCallback(updatedFilters);
    };

    const getDisabledStates = (): IGranularityFilterDisabledStatesRecord => {
        const durationObject: DatesRange = DurationService.getDurationObjectForCampaigns(widgetDuration);
        const updatedGranularityStates = getUpdatedGranularityItemsState(durationObject);
        return updatedGranularityStates.reduce((acc, granularityState) => {
            return { ...acc, [granularityState?.value?.toLowerCase()]: granularityState.disabled };
        }, {} as IGranularityFilterDisabledStatesRecord);
    };

    return (
        <RankTrackerOverviewPerformanceFiltersContainer
            key={KEY}
            className="filters"
        >
            <GenericDropdownFilter
                titleKey={TITLE_KEY}
                items={getTimeGranularityItems(getDisabledStates())}
                selectedId={filterObject[TIME_GRANULARITY] ?? DEFAULT_GRANULARITY}
                onSelect={(value) => onFilterChange(TIME_GRANULARITY, value.id)}
                filterContainerClass="overview-performance-dynamic-filters"
            />
        </RankTrackerOverviewPerformanceFiltersContainer>
    );
};
